import { render } from "./CategoryListPage.vue?vue&type=template&id=f25e8caa&scoped=true"
import script from "./CategoryListPage.vue?vue&type=script&lang=js"
export * from "./CategoryListPage.vue?vue&type=script&lang=js"

import "./CategoryListPage.vue?vue&type=style&index=0&id=f25e8caa&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f25e8caa"]])

export default __exports__